import { render, staticRenderFns } from "./RecExL.vue?vue&type=template&id=5def60b0"
import script from "./RecExL.vue?vue&type=script&lang=js"
export * from "./RecExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports